define([
	'jquery',
	'Handlebars'
	], function($, Handlebars) {

	'use strict';
	var DEBUG = false;

	if ( DEBUG ) console.log('search autosuggest helpers');
	
	// adds markup to suggested keywords. 
	Handlebars.registerHelper('highlightTerm', function (termSerched, suggestedKeyword) {
		var suggestionKeyword = suggestedKeyword.toLowerCase(),
		  	searchTerm = termSerched.toLowerCase();

		if ( DEBUG ) console.log(searchTerm, suggestionKeyword);

		return suggestionKeyword === searchTerm ? '<span class="search-term">' + searchTerm + '</span>' : suggestionKeyword.replace(searchTerm, '<span class="search-term">' + searchTerm + '</span>');				
	});

	Handlebars.registerHelper('decodedMarkup', function(text) {
		return text.replace(/&gt;/g, '>')
					.replace(/&amp;/g, '&')
					.replace(/&quot;/g, '"')
					.replace(/&#39;/g, "'")
					.replace(/&lt;/g, '<');

	});
});
